<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100 mobile-layout">
      <md-card class="mobile-card appeal-detail-card">
        <md-card-content class="mobile-content">
          <div class="appeals-detail-wrapper">
            <div v-if="!loader && appeal">
              <a href="#" v-if="!appeal.rating.awaiting" @click.prevent="ratingModal = true">Оценить</a>

              <div class="text-weight-bold text-main-black">
                {{ appeal.category ? appeal.category.fullName : 'Без категории' }}
              </div>
              <p class="text-main-black due-label">
                Срок выполнения: {{ appeal.dueDate | datetime }}
              </p>
              <md-divider></md-divider>
              <p class="text-main-black">
                {{ appeal.description }}
              </p>
              <md-divider></md-divider>
              <p class="text-main-black" v-if="appeal.performer">
                <span class="md-theme-block-head-color">Исполнитель:</span>
                <br>
                {{ appeal.performer.fullNamePosition }}
              </p>

              <div class="attachments-wrap">
                <a
                  v-for="(attachment,i) in sortByAttachOrder(attachments)"
                  :key="i"
                  :class="{'thumb-link' : attachment.thumbnail}"
                  :href="attachment.file"
                  @click.prevent="attachViewerHandler(attachment, sortByAttachOrder(attachments))"
                >
                  <image-thumbnail
                    v-if="attachment.thumbnail"
                    :pic="attachment.thumbnail" />
                  <file-thumbnail
                    v-else
                    :fileName="attachment.file"
                  />
                </a>
              </div>

            </div>
            <div v-else class="load-wrapper">
              <circle-loader :diameter="48" />
            </div>
          </div>

        </md-card-content>
      </md-card>
      <template v-if="!loader && appeal">
        <h5 class="text-main-black text-align-center" style="max-width: 785px;">
          СОБЫТИЯ
        </h5>

        <div class="history-events">
          <md-card class="event-item mobile-card" v-for="event in events" :key="event.id">
            <md-card-content>
              <div class="date-label">
                {{ event.createdAt | datetime }}
              </div>
              <div v-if="event.status" class="text-main-black">
                <span class="md-theme-block-head-color">Статус:</span> {{ event.status.name }}
              </div>
              <div v-if="event.rating.name" class="text-main-black">
                <span class="md-theme-block-head-color">Оценена:</span>
                <div class="wrap-rating">
                  <i class="material-icons icon-rating" :class="{'gold': event.rating.id > 0}">star</i>
                  <i class="material-icons icon-rating" :class="{'gold': event.rating.id > 1}">star</i>
                  <i class="material-icons icon-rating" :class="{'gold': event.rating.id > 2}">star</i>
                  <i class="material-icons icon-rating" :class="{'gold': event.rating.id > 3}">star</i>
                  <i class="material-icons icon-rating" :class="{'gold': event.rating.id > 4}">star</i>
                </div>
              </div>
              <div v-if="event.comment" class="text-main-black">
                {{ event.comment }}
              </div>
            </md-card-content>
          </md-card>
        </div>
      </template>
      <image-viewer-modal v-if="showImageViewer"/>
      <appeals-rating-control
        v-if="ratingModal"
        :showDialog="ratingModal"
        @onSubmit="updateRating"
        @closeDialog="ratingModal = false"
      />
    </div>
  </div>
</template>

<script>
import api from "@/api";
import to from "await-to-js";
import { mapGetters } from "vuex";
import CircleLoader from '@/components/Custom/CircleLoader';
import StarRatingControl from '@/components/Custom/StarRatingControl';
import AppealsRatingControl from '@/apps/appeals/components/AppealsRatingControl';
import ImageThumbnail from '@/components/Custom/ImageThumbnail';
import FileThumbnail from '@/components/Custom/FileThumbnail';
import ImageViewerModal from '@/components/Custom/ImageViewerModal';
import { sortByAttachOrder, isPicAttachment, isVideoAttachment } from '@/services';


export default {
  name: "AppealsDetail",
  components: {
    CircleLoader,
    StarRatingControl,
    AppealsRatingControl,
    ImageThumbnail,
    FileThumbnail,
    ImageViewerModal,
  },
  props: {
    id: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      appeal: null,
      events: null,
      loader: false,
      ratingModal: false
    }
  },
  computed: {
    ...mapGetters([
      'getUsername',
      'showImageViewer'
    ]),

    showStars() {
      const { status } = this.appeal;

      if (status) {
        return status.id === 4 || status.id === 6
      }
      return false
    },
    attachments() {
      if (this.appeal.attachments && this.appeal.attachments.length > 0) {
        return this.appeal.attachments.filter(file => !file.appealEvent).sort((e1,e2) => e1.order - e2.order);
      }
      return [];
    },

  },
  mounted() {
    this.fetchAppeals();
  },
  beforeDestroy() {
    this.$store.commit('SET_CURRENT_APPEAL_META', null)
  },
  methods: {
    sortByAttachOrder,

    attachViewerHandler(item, eventAttachments) {
      const link = item.file;

      if (isPicAttachment(item) || isVideoAttachment(item)) {
        this.$store.dispatch('SHOW_IMAGE_VIEWER');
        this.$store.dispatch('SET_IMAGE_VIEWER_DATA', {
          attachments: eventAttachments,
          initialSlideNumber: eventAttachments.findIndex((i) => i.file === link ),
        });
      } else {
        window.open(link, '_blank');
      }
    },

    async fetchAppeals() {
      const { id } = this;
      this.loader = true;

      const appealData = Promise.all([
        api.appeals.appeal({ id, username: this.getUsername }),
        api.appeals.appealEvents({ appealId: id, username: this.getUsername })
      ])
      const [err, resp] = await to(appealData);

      if (!err) {
        const appeal = resp[0].data;
        this.setMeta(appeal)
        this.appeal = appeal;
        this.events = resp[1].data.results;
      }

      this.loader = false;
    },

    async updateRating(data) {
      const params = {
        data,
        id: this.appeal.id,
        username: this.getUsername
      }
      const [err, resp] = await to(api.appeals.update(params));

      if (err) {
        this.$notifyDanger('Ошибка, попробуйте позже');
        return;
      }

      const appeal = resp.data;
      this.setMeta(appeal)
      this.appeal = appeal;
    },

    setMeta(appeal) {
      const label = `Заявка №${appeal.number} / ${this.$options.filters.date(appeal.createdAt)}`
      const ratingAwaiting = appeal.rating.awaiting
      this.$store.commit('SET_CURRENT_APPEAL_META', { label, ratingAwaiting })
    }
  }
};
</script>

<style lang="scss" scoped>
.appeal-detail-card {
  max-width: 785px;
  .md-card-content {
    padding: 25px 20px;
  }
  .history-events {
    padding-left: 10px;
  }
  .appeals-detail-wrapper {
    padding: 0 10px;
  }
  .appeals-detail-title {
    font-weight: 700;
    margin-top: 20px;
    margin-bottom: 5px;
  }
  .rating-link {
    font-size: 10px !important;
  }
  .load-wrapper {
    width: 100%;
    min-height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.event-item {
  max-width: 785px;
  margin-bottom: 10px;
  background-color: #ffffff;
  .due-label {
    margin-top: 0;
  }
  .date-label {
    position: absolute;
    right: 16px;
    bottom: 5px;
    font-size: 12px;
    color: var(--md-theme-text-light-grey-color);
  }
}
</style>
